/* eslint-disable no-unused-vars */
/* global G */

/**
 * Dispatches `G.CART, G.CREATE` to fetch (or create) the user's active cart.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {AttachmentEventListener}  an AttachmentEventListener
 */
const fn = app => async ({ detail = {} }) => {
  const adapter = app[G.ADAPTER][G.CART]
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const activeCart = adapter[G.DATA]

  if (activeCart?.key) {
    eventBus.dispatch(eventBus.type(G.CART, G.DONE), { [G.DATA]: activeCart })
  } else {
    eventBus.dispatch(eventBus.type(G.CART, G.CREATE))
  }
}

export default fn
